import { Root } from '@radix-ui/react-accordion';
import { ReactNode } from 'react';

type Props = {
  children: ReactNode;
  className?: string;
};

export default function Accordion({ className, children }: Props) {
  return (
    <Root className={className || ''} type="multiple">
      {children}
    </Root>
  );
}
